import styled from "styled-components";

export const FooterStyle = styled.div`
  .footer {
    width: 100%;
    background: radial-gradient(
        50% 50% at 50% 50%,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0) 100%
      ),
      #161616;
    font-family: thin-pro, sans-serif;
  }
  .footer2 {
    background: radial-gradient(
        50% 50% at 50% 50%,
        rgba(255, 255, 255, 0.1) 0%,
        rgba(255, 255, 255, 0) 100%
      ),
      #161616;
    font-family: thin-pro, sans-serif;
    position: absolute;
    padding-left: 20%;
    width: 100%;
  }

  .footerBrand {
    display: flex;
  }

  .footerNest {
    display: flex;
    padding: 4em 0;
    justify-content: center;
    font-family: thin-pro, sans-serif;
  }

  .foot_links {
    margin-right: 10em;
  }

  .foot_links_child {
    margin-bottom: 1em;
  }

  .footer_options {
    color: #cf8209;
    &:hover {
      color: rgb(242, 136, 9);
      text-decoration: underline;
    }
  }

  .social {
    font-size: 30px;
    margin: 0 0.75em 0 0;
    color: white;
  }

  .footerNest2 {
    padding: 4em 4em;
  }

  .footer_img {
    width: 57%;
    height: 45%;
  }
  .footer_img2 {
    width: 230px;
    height: 80px;
  }

  .foot_social {
    margin-bottom: 1em;
  }

  a {
    color: #f28809;
    text-decoration: none;
  }

  /* For large devices */
  @media screen and (min-width: 2560px) {
    .footer2 {
      padding-left: 20%;
    }
    .footer_img2 {
      width: 250px;
      height: 80px;
    }
  }
  @media screen and (max-width: 1440px) {
    .foot_links {
      margin-right: 5em;
    }
  }
  @media screen and (max-width: 1024px) {
    .foot_links {
      margin-right: 0em;
    }

    .footer_img {
      max-width: 60%;
      height: 40%;
    }
    .footer_img2 {
      width: 200px;
      height: 70px;
    }

    .footer2 {
      padding-left: 30%;
    }

    .social2 {
      font-size: 21px;
    }

    .footerBrand {
      justify-content: center;
    }
  }

  /* For medium devices */
  @media screen and (max-width: 800px) {
    .social {
      font-size: 22px;
    }

    .footer_img {
      max-width: 55%;
    }
    .footer_img2 {
      width: 200px;
      height: 70px;
    }

    .footer2 {
      padding-left: 0;
    }

    .footerBrand {
      justify-content: center;
    }
  }
  @media screen and (max-width: 576px) {
    .footer {
      width: 100%;
    }

    .foot_links {
      text-align: center;
    }
    .foot_social {
      text-align: center;
    }
    .footer2 {
      padding-left: 0;
    }
    .footerBrand {
      justify-content: center;
    }

    .footerNest {
      flex-direction: column;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: thin-pro, sans-serif;
    }

    .footer_img {
      max-width: 50%;
      margin-bottom: 2rem;
    }
    .footer_img2 {
      width: 200px;
      height: 50px;
      margin-bottom: 2rem;
    }

    .footer_options {
      font-size: 16px;
    }
    .social {
      font-size: 30px;
    }

    .img-logo {
      width: 30vh;
    }
  }

  /* For small devices */
  @media screen and (max-width: 350px) {
    .footer2 {
      padding-left: 0;
    }
    .foot_links {
      text-align: center;
    }

    .footer_img {
      max-width: 50%;
      margin-bottom: 2rem;
    }
    .footer_img2 {
      width: 150px;
      height: 50px;
      margin-bottom: 2rem;
    }
    .foot_social {
      text-align: center;
    }
  }
`;
